export default {
    basic: 'basic',
    url: 'url',
    firefly: 'firefly',
}
